// extracted by mini-css-extract-plugin
module.exports = {"container":"OurValues_container__pNRI6","leftCol":"OurValues_leftCol__7E_0b","rightCol":"OurValues_rightCol__53_gU","rightColContainer":"OurValues_rightColContainer__vLAu9"};